import { Link } from "@/lib/nav";

import SectionCard from "@buildpy/ui/section-card";
import { Button } from "@buildpy/ui/button";
import type { ChangeOrderStartBlock } from "@buildpy/core/modules/change-order/start-block";

// 변경공사를 더 진행할 수 없을 때 — 이유·다음 할 일·이동 버튼(첫 버튼이 주 행동).
const ChangeOrderBlock = ({ block }: { block: ChangeOrderStartBlock }) => (
  <SectionCard as="div" className="max-w-2xl text-sm" padding="sm" data-testid="change-order-blocked">
    <p className="font-semibold">{block.message}</p>
    <p className="mt-1 text-muted-foreground">{block.hint}</p>
    <div className="mt-3 flex flex-wrap gap-2">
      {block.next.map((n, i) => (
        <Button key={n.href} asChild size="sm" variant={i === 0 ? "primary" : "outline"}>
          <Link href={n.href}>{n.label}</Link>
        </Button>
      ))}
    </div>
  </SectionCard>
);

export default ChangeOrderBlock;
